import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';

export interface IInfoDialogConfig {
    content?: React.ReactNode;
    title: string;
}

export interface IInfoDialogState {
    config: IInfoDialogConfig | null;
}

export const infoDialogSlice = createSlice({
    name: 'infoDialog',
    initialState: { config: null } as IInfoDialogState,
    reducers: {
        update: (state, action: PayloadAction<IInfoDialogConfig | null>) => {
            state.config = action.payload;
        },
    },
});

export const { update } = infoDialogSlice.actions;
export const infoDialogConfig = (state: IGlobalStoreReducers) => state.infoDialog.config;

export default infoDialogSlice.reducer;
